import { ISearchPage, IPage,ICmSearchPageFields } from "../../../types/FmsTypes";
import { httpRequest } from "../../../utils/HttpRequest";


//详情
export interface ISCMShopDetail {
    id: string,              // "bf9dc1a3b9647038f96e545229b25e72",
    code: string,              // "ETY-M-gSUn-00000019",
    orderNum: string,              // 0,
    deleteFlag: string,              // 0,
    createTime: string,              // ,
    updateTime: string,              //,
    createUser: string,              // "默认用户",
    updateUser: string,              // "默认用户",
    branch: string,              // "main",
    ver: string,              // 6,
    enable: string,              // null,
    orgCode: string,              // "机构编码",
    orgName: string,              // "机构名称",
    name: string,              // "门店名称",
    contact: string,              // "联系人",
    phone: string,              // "332",
    address: string,              // "地址",
    categoryCode: string,              // "门店类型",
    categoryName: string,              // "门店类型名称",
    status: number,              // 1,
    note: string,              // "备注",
    details: ISCMBeDetails[],              // 
}

//门店 实体
export interface ISCMBeDetails {
    id: string,                // "911332111d8134f89b45490410550079",
    code: string,                // null,
    orderNum: string,                // 0,
    deleteFlag: string,                // 0,
    createTime: string,                //,
    updateTime: string,                //,
    createUser: string,                // "默认用户",
    updateUser: string,                // null,
    shopCode: string,                // "ETY-M-gSUn-00000019",
    bentityCode: string,                // "实体编码-",
    bentityName: string,                // "实体名称-"
}

//新增
export interface ISCMShopInsert {
    orgCode: string,    // "机构编码",
    orgName: string,    // "机构名称",
    address: string,    // "地址",
    contact: string,    // "联系人",
    branch: string,    // "main",
    phone: string,    // "332",
    name: string,    // "门店名称",
    categoryCode: string,    // "门店类型",
    categoryName: string,    // "门店类型名称",
    note?: string,    // "备注",
    details: {
        shopCode: string,     // "备注",
        bentityCode: string,     // "实体编码",
        bentityName: string,     // "实体名称"
    }[],    
    status: number,
    code?:string
}

//编辑
export interface ISCMShopUpdate extends ISCMShopInsert {
    id: string,
}

//搜索条件
export interface ISCMShopSearchFields {
    enable?: string,      // "分支",
    stuats?: string,      // "状态",
    orgCode?: string,      // "机构编码",
    name?: string,      // "门店名称",
    sourceApp?: string,      // "mdm",
}

export interface ISCMShopSearch
    extends ISCMShopSearchFields, ICmSearchPageFields {
}

//表单字段
export interface ISCMShopFormFields {
    branch: string,
    code?: string,
    name: string,
    orgCode: string,
    orgName: string,
    contact: string,
    phone: string,
    address: string,
    status: boolean,
    categoryCode: string,
    categoryName: string,
    details: string[],
    note?: string,
}

class ShopService {
    async page(searchVo: ISCMShopSearch) {
        const apiUrl = "/md/shop/page";
        return await httpRequest.post<IPage<ISCMShopDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/md/shop/findById/${id}`;
        return await httpRequest.get<ISCMShopDetail>(apiUrl);
    }
    async insert(insertVo: ISCMShopInsert) {
        const apiUrl = "/md/shop/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: ISCMShopUpdate) {
        const apiUrl = "/md/shop/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(id: string, status: number) {
        const apiUrl = `/md/shop/enableOrDisable/${id}/${status}`;
        return await httpRequest.get<boolean>(apiUrl);
    }

}

export const shopService = new ShopService();
